// extracted by mini-css-extract-plugin
export default {"tela":"ErrorBoundary_tela__J-vNC","titulo":"ErrorBoundary_titulo__ALkcm","apoio":"ErrorBoundary_apoio__4dg1S","botao":"ErrorBoundary_botao__LlOYF"};